import React from 'react';
import { Formik } from 'formik';
import { useToast } from '@chakra-ui/react';
import { localise, templateReplace } from '../../../../services/lang/lang';
import useGenericMutationUseCase from '../../../../hooks/usecases/generic/useGenericMutationUseCase';
import { useUpdateContact } from '../../../../services/api/generated/client';
import ContactFormWrapper from './ContactFormWrapper';
import SuspenseWrapper from '../../SuspenseWrapper/SuspenseWrapper';
import { isOccupant } from '../../../../services/contacts';
import { manualAddressToAddress, } from '../../../../services/ui/addresses';
import ContactFormShareWrapper from './Share/ContactFormShareWrapper';
import RenderIfElse from '../../RenderIf/RenderIfElse';
import FormikModalErrorSync from '../../Modal/FormikModalErrorSync';
const EditContactWrapper = ({ contact, canEdit, variant, isShare, onEditContact, }) => {
    const updateContact = useGenericMutationUseCase(useUpdateContact);
    const toast = useToast();
    const initialValues = {
        contact_type_id: contact?.contact_type_id,
        full_name: contact?.full_name ?? '',
        email: contact?.email ?? '',
        phone: contact?.phone ?? '',
        postcode: '',
        address: contact?.address,
        organisation_name: contact?.organisation_name,
        manual_address: undefined,
        occupant: isOccupant(contact)
            ? {
                occupant_age_range_id: contact?.occupant?.occupant_age_range_id,
                occupancy_date: contact?.occupant?.occupancy_date,
                gender: contact?.occupant?.gender,
                household_id: contact?.occupant?.household_id,
                tenant: {
                    tenancy_type_id: contact?.occupant?.tenant?.tenancy_type_id,
                },
            }
            : null,
    };
    const onSubmit = (values, helpers) => {
        const address = values.address ??
            (values.manual_address
                ? manualAddressToAddress(values.manual_address)
                : null);
        const data = {
            ...values,
            address,
        };
        updateContact.execute({
            id: contact.id,
            data,
        }, helpers, {
            onSuccess: () => {
                toast({
                    title: templateReplace(localise('UPDATED'), {
                        noun: localise('CONTACT'),
                    }),
                    status: 'success',
                    isClosable: true,
                });
                onEditContact();
            },
        });
    };
    return (React.createElement(SuspenseWrapper, null,
        React.createElement(Formik, { initialValues: initialValues, onSubmit: onSubmit },
            React.createElement(React.Fragment, null,
                React.createElement(FormikModalErrorSync, null),
                React.createElement(RenderIfElse, { condition: isShare, then: React.createElement(ContactFormShareWrapper, { variant: variant }), else: React.createElement(ContactFormWrapper, { variant: variant, inspectionId: contact.inspection_id, canEdit: canEdit }) })))));
};
export default EditContactWrapper;
